import { useLocation, useMatch } from 'react-router';

export const DETAIL_MODE = {
  EDIT: 'edit',
  NEW: 'new',
  STATIC: 'static',
};

export const DETAIL_TYPE = {
  DOCUMENT: 'document',
  CONTROL: 'control',
  TEMPLATE: 'template',
  QUALITY: 'quality',
};

export const useDetailMode = (type) => {
  const location = useLocation();
  const matchEdit = useMatch(`/${type}/:id/edit`);

  const matchStatic = useMatch({ path: `/${type}/:id`, end: true });
  const matchNew = useMatch(`/${type}/new`);
  const matchNewWithId = useMatch(`/${type}/new/:id`);
  const matchTemplate = useMatch(`/${DETAIL_TYPE.TEMPLATE}/*`);

  // Snapshot mode: from a URL query param (?snapshot={auditLogId}) OR legacy location.state
  const searchParams = new URLSearchParams(location.search);
  const snapshotAuditLogId = searchParams.get('snapshot');
  const isSnapshotMode = !!snapshotAuditLogId || location.state?.isSnapshot || false;
  const isMasterPreview = location.state?.source === 'master';

  const mode = isSnapshotMode
    ? DETAIL_MODE.STATIC
    : matchNew || matchNewWithId
      ? DETAIL_MODE.NEW
      : matchEdit || matchTemplate
        ? DETAIL_MODE.EDIT
        : DETAIL_MODE.STATIC;

  return {
    mode,
    isEdit: mode === DETAIL_MODE.EDIT,
    isMasterPreview,
    isNew: matchNew,
    isReadOnly: isSnapshotMode || isMasterPreview,
    isSnapshotMode,
    isStatic: matchStatic,
  };
};
